import React from 'react'

function Column3333Icon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="46"
      height="34"
      viewBox="0 0 46 34"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polygon points="36.5 0.5 36.5 33.5 43.5 33.5 43.5 0.5" />
      <polygon points="25.5 0.5 25.5 33.5 32.5 33.5 32.5 0.5" />
      <polygon points="13.5 0.5 13.5 33.5 20.5 33.5 20.5 0.5" />
      <polygon points="2.5 0.5 2.5 33.5 9.5 33.5 9.5 0.5" />
    </svg>
  )
}

export default Column3333Icon
